package or.garden.manager.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class ApiResponse<T>(
    val status: String,
    val message: String,
    val data: T? = null
) {
    companion object {
        fun <T> success(message: String, data: T? = null) = ApiResponse(
            status = "success",
            message = message,
            data = data
        )

        fun <T> error(message: String) = ApiResponse<T>(
            status = "error",
            message = message,
            data = null
        )
    }
}
